import { render, staticRenderFns } from "./wibo.vue?vue&type=template&id=168a836c&lang=pug&"
import script from "./wibo.vue?vue&type=script&lang=js&"
export * from "./wibo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports